export function obterListaIndicadorIntermediario() {
  return (
    [
      { label: 'Operação sem intermediador', value: 'NAO' },
      { label: 'Operação em site ou plataforma de terceiros', value: 'SIM' },
    ]
  );
}
